import { breakpoints } from '@shared/utils/style/breakpoints';
import { Box, styled } from '@withjoy/joykit';

export const PhotosCardsWrapper = styled(Box)<{ itemCount: number }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 24px;
  @media (min-width: ${breakpoints.xs}) {
    grid-template-columns: ${({ itemCount }) => (itemCount > 0 ? 'repeat(2, minmax(0, 1fr))' : '1fr')};
  }
  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: ${({ itemCount }) => (itemCount > 0 ? 'repeat(3, minmax(0, 1fr))' : '1fr')};
  }
  @media (min-width: ${breakpoints.sm2}) {
    grid-template-columns: ${({ itemCount }) => (itemCount > 0 ? 'repeat(4, minmax(0, 1fr))' : '1fr')};
  }
`;
